import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from "../../shared/shared.module";
import {PointOfSaleRoutingModule} from "./point-of-sale-routing.module";
import {PointOfSaleEditComponent} from "./edit/point-of-sale-edit.component";
import {OfficeLocationComponent} from "./edit/office-location/office-location.component";
import {DeliveryInstructionsComponent} from "./delivery-instructions/delivery-instructions.component";
import {DefaultInstructionsComponent} from "./delivery-instructions/default-instructions/default-instructions.component";
import {MiamiIndicationsPosComponent} from "./delivery-instructions/miami-indications-pos/miami-indications-pos.component";
import {MiamiInstructionsComponent} from "./delivery-instructions/miami-instructions/miami-instructions.component";
import {OrlandoInstructionsComponent} from "./delivery-instructions/orlando-instructions/orlando-instructions.component";
import {CancunInstructionsComponent} from "./delivery-instructions/cancun-instructions/cancun-instructions.component";
import {OrlandoModalNewDeliveryPointComponent} from "./delivery-instructions/orlando-instructions/orlando-modal-new-delivery-point.component";
import {BusinessHoursComponent} from "./edit/business-hours/business-hours.component";
import {GeneralSettingComponent} from "./edit/general-setting/general-setting.component";
import {SpecialAttentionHoursComponent} from "./edit/special-attention-hours/special-attention-hours.component";
import {PhoneContainerComponent} from "../additionalPoint/phone-component/phone.container.component";
import {TextMaskModule} from "angular2-text-mask";
import {SelectorComponent} from "../additionalPoint/selector/selector.component";

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, PointOfSaleRoutingModule, TranslateModule, SharedModule, TextMaskModule],
    declarations: [
        PointOfSaleEditComponent, OfficeLocationComponent, BusinessHoursComponent, GeneralSettingComponent,
        DeliveryInstructionsComponent, DefaultInstructionsComponent,
        MiamiIndicationsPosComponent, MiamiInstructionsComponent,
        OrlandoInstructionsComponent, OrlandoModalNewDeliveryPointComponent,
        CancunInstructionsComponent,
        SpecialAttentionHoursComponent, PhoneContainerComponent],
    exports:[
        OfficeLocationComponent, DeliveryInstructionsComponent,DefaultInstructionsComponent,
        MiamiIndicationsPosComponent, MiamiInstructionsComponent,
        OrlandoInstructionsComponent, OrlandoModalNewDeliveryPointComponent,
        CancunInstructionsComponent,
        PhoneContainerComponent],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class PointOfSaleModule {}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/point-of-sale.module.ts